import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var CalendarTodaySmallOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CalendarTodaySmallOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a.5.5 0 0 1 .5.5v.375h5V1.5a.5.5 0 0 1 1 0v.384c.865.02 1.412.089 1.862.318a3 3 0 0 1 1.311 1.311C15 4.155 15 4.995 15 6.675V10.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C12.72 15 11.88 15 10.2 15H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C1 12.72 1 11.88 1 10.2V6.675c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311c.45-.23.997-.298 1.862-.318V1.5A.5.5 0 0 1 5 1Zm5.5 1.875V3.5a.5.5 0 0 0 1 0v-.616c.222.006.415.014.589.029.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819.006.068.01.14.015.214H2.023c.004-.075.009-.146.015-.214.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.174-.015.367-.023.589-.029V3.5a.5.5 0 0 0 1 0v-.625h5ZM2.001 6h11.998l.001.675V10.2c0 .857 0 1.439-.038 1.889-.035.438-.1.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.38.145-.819.18-.45.037-1.032.038-1.889.038H5.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C2 11.639 2 11.057 2 10.2V6.675L2.001 6Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CalendarTodaySmallOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default CalendarTodaySmallOutline;